<dx-popup
    #viewerpopup
    width="99%"
    height="99%"
    [title]="popupTitle"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'" class="popup-content">
        <dx-box height="100%" width="100%" direction="col">
            <dxi-item [ratio]="1" class="cc-white-background">
                <div *dxTemplate>
                    <div class="splitter-container">
                        <as-split
                            class="as-split"
                            direction="horizontal"
                            unit="percent"
                            gutterSize="5"
                            [useTransition]="true"
                            (dragStart)="onSplitterDragStart()"
                            (dragEnd)="dragEndPdfLeft($event)"
                        >
                            <as-split-area
                                class="as-split-area"
                                [size]="pdfViewerWidth"
                                [order]="pdfOrder"
                                [visible]="!separateWindow"
                            >
                                <app-workflow-invoice-viewer
                                    #invoiceViewer
                                    [source]="pdfURL"
                                    [loader]="pdfLoader"
                                ></app-workflow-invoice-viewer>
                            </as-split-area>
                            <as-split-area [size]="formPanelWidth" [order]="invoiceOrder">
                                <ng-container *ngIf="!viewOnly">
                                    <app-workflow-reclassify
                                        [apBillDetailParam]="apBillDetailParam"
                                        (pdfURL)="onPdfURL($event)"
                                        (pdfLoader)="onPdfLoader($event)"
                                        (splitterPositionChange)="onSplitterPositionChange($event)"
                                        (hideSplitter)="onHideSplitter($event)"
                                        (titleChange)="onTitleChange($event)"
                                        (onClose)="onReclassifyClose($event)"
                                    ></app-workflow-reclassify>
                                </ng-container>
                                <ng-container *ngIf="!!viewOnly">
                                    <app-workflow-detail-viewer
                                        [workflowId]="workflowId"
                                        [communityId]="communityId"
                                        (pdfURL)="onPdfURL($event)"
                                        (pdfLoader)="onPdfLoader($event)"
                                        (splitterPositionChange)="onSplitterPositionChange($event)"
                                        (hideSplitter)="onHideSplitter($event)"
                                        (onClose)="onViewerClose()"
                                        (onReclassifyWorkflow)="onReclassifyWorkflow($event)"
                                    ></app-workflow-detail-viewer>
                                </ng-container>
                            </as-split-area>
                        </as-split>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
